import * as React from 'react';

import classnames from 'classnames';

import {colors} from '../colors/colors';
import {MessageIconSolid} from '../icon/svg/message-icon-solid';
import {Body} from '../typography/body';

import {linkifyStyle} from './helpers';

import styles from './read-only-text.module.css';

type Props = {
    message: string;
    optOutText?: string;
    includeIcon?: boolean;
    isFullWidth?: boolean;
    hasLineLimit?: boolean;
    backgroundColor?: 'white' | 'offWhite';
    size?: 'mini' | 'small' | 'normal' | 'large';
};

export function ReadOnlyText(props: Props) {
    const {backgroundColor = 'offWhite', isFullWidth = false} = props;

    const containerStyleNames = classnames({
        [styles.white]: backgroundColor === 'white',
        [styles['off-white']]: backgroundColor === 'offWhite',
    });

    const messageStyleNames = classnames({
        [styles['message-tail']]: true,
        [styles['message--full-width']]: isFullWidth,
        [styles.message]: !isFullWidth,
    });

    const contentStyleName = classnames({
        [styles['message-content']]: true,
        [styles['message-content--truncated']]: props.hasLineLimit,
    });

    // Should have the same format as models/Sms/Edition.php
    const fullMessage = props.optOutText
        ? `${props.message}\n\n${props.optOutText}`
        : props.message;

    return (
        <div className={containerStyleNames}>
            <div className={messageStyleNames}>
                <div className={contentStyleName}>
                    {props.includeIcon && (
                        <div className={styles.icon}>
                            {/* @ts-expect-error */}
                            <MessageIconSolid color={colors.grey} size={20} />
                        </div>
                    )}
                    <Body maintainLineBreaks size={props.size || 'normal'}>
                        {linkifyStyle(fullMessage)}
                    </Body>
                </div>
            </div>
        </div>
    );
}
